import { Input, Label } from 'reactstrap'
import React from 'react'

const TextField = (props) => {
  const { id, name, value, style, className, placeholder, type, disabled, maxLength, min, onChange, title, required, onClick, requiredText} = props
  const handleChange = (e) => {
    onChange && onChange(e)
  }

  const handleClick = (e) => {
    onClick && onClick(e)
  }

  // const theme = {
  //   control: (styles, { isDisabled }) => ({
  //     ...styles,
  //     width: '100px',
  //     // height: height,
  //     // backgroundColor: isDisabled ? "rgb(167, 167, 167)" : "white",
  //     // border: isRequired ? '1px solid red': "",
  //     // fontSize: "14px",
  //     // "&:hover": {
  //     //   cursor: "pointer",
  //     // },
  //   })
  //   // width ? width :

  // };

  return (
   <>
   <Input
    id={id}
    name={name}
    label={name}
    value={value}
    style={style}
    className={className}
    placeholder={placeholder}
    type={type}
    disabled={disabled}
    maxLength={maxLength}
    min={min}
    onChange={handleChange}
    title={title}
    required={required}
    onClick={handleClick}
   >
   </Input>
   {required ? <Label style={{fontSize:'12px', margin:'0px', color:'red'}}>{requiredText}</Label>:""}
   
   </>
  )
}

export default TextField